import { Container, Box, Badge } from "@cloudscape-design/components";
import { useNavigate } from "react-router-dom";
import { OrganizationCardProps } from "../../types/organizationTypes";
import "../../styles/common.css";

const OrganizationCard = ({ organization }: OrganizationCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="organization-card"
      onClick={() => navigate(`/organizations/${organization.id}`)}
    >
      <Container >
        <div className="clickable">
        <Box variant="h3">
          {organization.display_name}
          {organization.isDefault && <Badge color="blue">default</Badge>}
        </Box>
        <Box variant="small" padding={{ top: 's', bottom: 'm' }}>{organization.name}</Box>
        <div className="card-style">
          <Box>
            <Box variant="h1">{organization.membersCount}</Box>
            <Box variant="small">Members</Box>
          </Box>
          <Box>
            <Box variant="h1">{organization.domainsCount}</Box>
            <Box variant="small">Domains</Box>
          </Box>
        </div>
        </div>
      </Container>
    </div>
  );
};

export default OrganizationCard;
